import type { ComputedRef } from 'vue';

export type SupportLang = 'ZH-cn' | 'En';

export interface ColorPickerProvider {
  lang: ComputedRef<SupportLang>;
}

export type Placement =
  | 'auto'
  | 'auto-start'
  | 'auto-end'
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'right-start'
  | 'right-end'
  | 'left-start'
  | 'left-end';

export const ColorPickerProviderKey = 'Vue3ColorPickerProvider';
